<template>
    <div class="page_banner_mobile">
        <div class="group_204 flex-col">
            <div class="group_7 flex-col">
                <!-- 轮播容器 -->
                <div class="box_4 flex-col" @mouseenter="pauseAutoPlay" @mouseleave="resumeAutoPlay">
                    <!-- 轮播图片 -->
                    <div
                            v-for="(img, index) in banners"
                            :key="index"
                            class="banner-item"
                            :class="{ active: currentIndex === index }"
                            :style="{ backgroundImage: `url(${img})` }"
                    ></div>

                    <!-- 内容区域 -->
                    <div class="content-container">
                        <div class="box_banner_text_wrap flex-row justify-between">
                            <!-- 原有文本内容 -->
                            <div class="text-group_406 flex-col">
                                <span class="text_8">愿景和使命</span>
                                <span class="text_9">致力成为全球化商业组织的健康管理专家</span>
                                <span class="text_10">助力企业实现可持续发展</span>
                            </div>
                        </div>
                        <div class="box_196 flex-row">
                            <div class="text-wrapper_2 flex-col"
                                 @click="goto('contact')"
                            ><span class="text_11">联系我们</span></div>
                        </div>
                    </div>

                    <!-- 指示器 -->
                    <div class="indicators">
                        <div
                                v-for="(item, index) in banners"
                                :key="index"
                                class="indicator"
                                :class="{ active: currentIndex === index }"
                                @click="switchBanner(index)"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                currentIndex: 0,
                timer: null,
                banners: [
                    require('../../../assets/tempImg/banner01.png'),
                    //require('../../../assets/tempImg/banner01.png'), // 添加更多图片
                    //require('../../../assets/tempImg/banner01.png')
                ]
            };
        },
        mounted() {
            this.startAutoPlay();
        },
        beforeUnmount() {
            this.clearAutoPlay();
        },
        methods: {
            goto(url){
                url = '/' + url;
                this.$router.push(url);
            },
            startAutoPlay() {
                this.timer = setInterval(() => {
                    this.currentIndex = (this.currentIndex + 1) % this.banners.length;
                }, 5000);
            },
            pauseAutoPlay() {
                this.clearAutoPlay();
            },
            resumeAutoPlay() {
                this.startAutoPlay();
            },
            clearAutoPlay() {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            },
            switchBanner(index) {
                this.currentIndex = index;
            }
        }
    };
</script>

<style scoped lang="css"  >

    .page_banner_mobile {
        width: 100%;
        overflow: hidden;
    }

    .box_4 {
        position: relative;
        overflow: hidden;
        height: 300px;
        width: 100%;
    }

    .banner-item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 1s ease-in-out;
        background-size: cover;
        background-position: center;

        background-repeat: no-repeat;
    }

    .banner-item.active {
        opacity: 1;
    }

    .content-container {
        position: relative;
        z-index: 2; /* 保证内容在轮播图之上 */
    }


    /* 指示器样式 */
    .indicators {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 6px;
        z-index: 3;
    }

    .indicator {
        width: 30px;
        height: 4px;
        background: rgba(255,255,255,0.3);
        border-radius: 2px;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .indicator.active {
        width: 43px;
        background: #FFFFFF;
        border-radius: 2px;
    }

    .group_204 {
        width: 100%;
    }

    .group_7 {
        width: 100%;
    }

    .box_banner_text_wrap {
        max-width: 100%; /* 修改：宽度自适应 */
        height: auto; /* 修改：高度自适应 */
        margin: 20px 0 0 0; /* 修改：调整边距 */
        margin-left: 40px;
        padding: 0 15px; /* 新增：添加内边距 */
    }

    .text-group_406 {
        width: 100%;
        height: auto;
    }

    .text_8 {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 32px;
        font-family: AlibabaPuHuiTi_3_85_Bold;
        text-align: left;
        white-space: nowrap;
        line-height: 53px;
        margin-right: 232px;
    }

    .text_9 {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin-top: 13px;
    }

    .text_10 {
        height: 34px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
    }

    .box_196 {
        width: 100%;
        height: auto;
        margin: 20px 0 0 0;
        margin-left: 40px;
        padding: 0 15px;
        justify-content: center;
    }

    .text-wrapper_2 {
        height: 35px;
        background: url(../../../assets/home/home_contact_me.png)
        100% no-repeat;
        background-size: 100% 100%;
        width: 140px;
        cursor: pointer;
        align-items: center;
        transition: all 0.3s ease; /* 添加过渡动画 */
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    /* 悬停状态 */
    .text-wrapper_2:hover {
        transform: translateY(-2px); /* 轻微上移效果 */
    }

    /* 点击状态 */
    .text-wrapper_2:active {
        transform: translateY(1px);
        filter: brightness(0.9); /* 点击时变暗 */
    }

    .text_11 {
        width: 74px;
        height: 34px;
        overflow-wrap: break-word;
        color: rgba(31, 128, 115, 1);
        font-size: 18px;
        letter-spacing: 0.6000000238418579px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        text-align: center;
        white-space: nowrap;
        line-height: 34px;
        margin: 0px 0 0 0;
    }

    @media (min-width: 481px) and (max-width: 700px) {

    }
    @media (max-width: 480px) {
        .box_banner_text_wrap {
            margin: 20px 0 0 0; /* 修改：调整边距 */
            margin-left: 20px;
            padding: 0 15px; /* 新增：添加内边距 */
        }
        .text_8 {
            font-size: 18px;
            line-height: 25px;
        }

        .text_9, .text_10 {
            font-size: 10px;
            line-height: 16px;
        }

        .text-wrapper_2 {
            width: 120px;
            height: 36px;
        }

        .text-wrapper_2 {
            height: 22px;
            width: 80px;
            cursor: pointer;
            transition: all 0.3s ease; /* 添加过渡动画 */
        }
        .text_11 {
            font-size: 12px;
            height: 16px;
            line-height: 22px;
            margin: 0px 0 0 0;
        }

        .box_4 {
            position: relative;
            overflow: hidden;
            height: 150px;
            width: 100%;
        }
        .box_196 {
            width: 100%;
            height: auto;
            margin: -5px 0 0 0;
            margin-left: 20px;
            padding: 0 15px;
            justify-content: center;
        }

        .indicator {
            width: 20px;
            height: 2px;
            background: rgba(255,255,255,0.3);
            border-radius: 2px;
            cursor: pointer;
            transition: all 0.3s ease;
        }

        .indicator.active {
            width: 20px;
            background: #FFFFFF;
            border-radius: 2px;
        }

    }

    @media (max-width: 390px) {
        .box_banner_text_wrap {
            margin: 20px 0 0 0; /* 修改：调整边距 */
            margin-left: 20px;
            padding: 0 15px; /* 新增：添加内边距 */
        }
        .text_8 {
            font-size: 18px;
            line-height: 25px;
        }

        .text_9, .text_10 {
            font-size: 10px;
            line-height: 16px;
        }


        .text-wrapper_2 {
            height: 22px;
            width: 80px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.3s ease; /* 添加过渡动画 */
        }
        .text_11 {
            font-size: 12px;
            height: 16px;
            line-height: 17px;
            margin: 0px 0 0 0;
        }

        .box_4 {
            position: relative;
            overflow: hidden;
            height: 150px;
            width: 100%;
        }
        .box_196 {
            width: 100%;
            height: auto;
            margin: -5px 0 0 0;
            margin-left: 20px;
            padding: 0 15px;
            justify-content: center;
        }

        .indicator {
            width: 20px;
            height: 2px;
            background: rgba(255,255,255,0.3);
            border-radius: 2px;
            cursor: pointer;
            transition: all 0.3s ease;
        }

        .indicator.active {
            width: 20px;
            background: #FFFFFF;
            border-radius: 2px;
        }

    }


</style>
